import {Observable} from "rxjs/Rx";
import {IUserInformationsWebServiceClient, UserInformations} from "@resources/resources";
import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";
import {CerbaAuthService, CerbaCookieService, CookieConstantes, UserStore} from "@digicerba/common";

@Injectable()
export class UserResolver implements Resolve<UserInformations> {

  constructor(private iUserInformationsWebServiceClient: IUserInformationsWebServiceClient,
              private userStore: UserStore, private cerbaAuthService: CerbaAuthService, private cookieService: CerbaCookieService) {
  }

  resolve() {
    const authCookieValue = this.cookieService.getCoockieValue(CookieConstantes.COOKIE_AUTH);
    if (authCookieValue) {
      try {
        let userCall = this.iUserInformationsWebServiceClient.me();
        userCall.subscribe(user => {
          this.userStore.setUser(user);
        });
        return userCall;
      } catch (e) {
        console.log("no me." + e);
      }
    } else {
      this.userStore.setUser(new UserInformations());
    }
    return Observable.of(null);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/src/app/pages/cerba/user.resolver.ts